import DPDropDown from "framework/components/DPDropDown";
import React, { useState } from "react"
import { CardText, Col, Row, Alert } from "reactstrap"

import DPTextBox from "../../../framework/components/DPTextBox"


const VendorMasterTab2 = ({
  fieldManager,
  Address1Value,
  Address1onChange,
  Address2Value,
  Address2onChange,
  Address3Value,
  Address3onChange,
  Address4Value,
  Address4onChange,
  SupAreaValue,
  SupAreaonChange,
  Mobile1Value,
  Mobile1onChange,
  Mobile2Value,
  Mobile2onChange,
  Mobile3Value,
  Mobile3onChange,
  Mobile4Value,
  Mobile4onChange,
  FaxValue,
  FaxonChange,
  EmailValue,
  EmailonChange,
  ContPersonValue,
  ContPersononChange,
  ContPersonIDValue,
  ContPersonIDonChange,
  show,
  disabled,
  AlertColor,
  AlertMsg,
  ErrorMsg
}) => {
  const [optionGroup, setoptionGroup] = useState([]);

  //  api call to suplier area
  React.useEffect(async () => {
    const authToken = localStorage.getItem("authToken")
    var requestOptions = {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${authToken}`
      },
      redirect: 'follow'
    };

    const ApiURL = window.Links.ApiURL
    await fetch(`${ApiURL}SupplierArea/Select`, requestOptions)
      .then(response => response.json())
      .then(result => {
        setoptionGroup(result.data)
        let dt = result.data
      })
      .catch(error => console.log('error', error));
  }, []);

  return (
    <React.Fragment>
      {/* {console.log(fieldManager)} */}
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              {show ? (
                <Alert color={AlertColor} role="alert">
                  {AlertMsg}
                  <br />
                  <small>{ErrorMsg}</small>
                </Alert>
              ) : null}
              <Row>
                <Col sm={12} md={6} className="mb-4-sm">

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_ADD1')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Address *"
                      textType="text"
                      placeholder="Address Line 1"
                      maxLength="50"
                      value={Address1Value}
                      onChange={Address1onChange}
                      disabled={disabled || fieldManager.disable.includes('SM_ADD1')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_ADD2')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="&nbsp;"
                      textType="text"
                      placeholder="Address Line 2"
                      maxLength="50"
                      value={Address2Value}
                      onChange={Address2onChange}
                      disabled={disabled || fieldManager.disable.includes('SM_ADD2')}
                    />
                  </div>


                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_ADD3')}>
                    <DPTextBox
                      rowClass="mb-7-sm"
                      labelText="&nbsp;"
                      textType="text"
                      placeholder="Address Line 3"
                      maxLength="50"
                      value={Address3Value}
                      onChange={Address3onChange}
                      disabled={disabled || fieldManager.disable.includes('SM_ADD3')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_ADD4')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="&nbsp;"
                      textType="text"
                      placeholder="Address Line 4"
                      maxLength="50"
                      value={Address4Value}
                      onChange={Address4onChange}
                      disabled={disabled || fieldManager.disable.includes('SM_ADD4')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_AREA')}>
                    <DPDropDown
                      labelText="Area of the supplier *"
                      rowClass="mb-4-sm"
                      optionGroup={optionGroup}
                      selectedGroup={SupAreaValue}
                      onChange={SupAreaonChange}
                      disabled={disabled || fieldManager.disable.includes('SM_AREA')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_MOBILE1')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Mobile *"
                      textType="text"
                      maxLength="10"
                      placeholder="Mobile 1"
                      value={Mobile1Value}
                      onChange={Mobile1onChange}
                      disabled={disabled || fieldManager.disable.includes('SM_MOBILE1')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_MOBILE2')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="&nbsp;"
                      textType="text"
                      maxLength="10"
                      placeholder="Mobile 2"
                      value={Mobile2Value}
                      onChange={Mobile2onChange}
                      disabled={disabled || fieldManager.disable.includes('SM_MOBILE2')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_PHONE1')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Telephone"
                      textType="text"
                      maxLength="10"
                      placeholder="Telephone 1"
                      value={Mobile3Value}
                      onChange={Mobile3onChange}
                      disabled={disabled || fieldManager.disable.includes('SM_PHONE1')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_PHONE2')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="&nbsp;"
                      textType="text"
                      maxLength="10"
                      placeholder="Telephone 2"
                      value={Mobile4Value}
                      onChange={Mobile4onChange}
                      disabled={disabled || fieldManager.disable.includes('SM_PHONE2')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_FAX')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Fax No"
                      textType="text"
                      maxLength="10"
                      value={FaxValue}
                      onChange={FaxonChange}
                      disabled={disabled || fieldManager.disable.includes('SM_FAX')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_EMAIL')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Email"
                      textType="text"
                      maxLength="15"
                      value={EmailValue}
                      onChange={EmailonChange}
                      disabled={disabled || fieldManager.disable.includes('SM_EMAIL')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_CONTACT')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Contact Person"
                      textType="text"
                      maxLength="15"
                      value={ContPersonValue}
                      onChange={ContPersononChange}
                      disabled={disabled || fieldManager.disable.includes('SM_CONTACT')}
                    />
                  </div>

                  <div hidden={fieldManager.hidden == true && fieldManager.disable.includes('SM_CONTACTID')}>
                    <DPTextBox
                      rowClass="mb-4-sm"
                      labelText="Contact Person ID"
                      textType="text"
                      maxLength="50"
                      value={ContPersonIDValue}
                      onChange={ContPersonIDonChange}
                      disabled={disabled || fieldManager.disable.includes('SM_CONTACTID')}
                    />
                  </div>

                </Col>

              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default VendorMasterTab2
